import React, { useState, useEffect, useRef } from "react";
import "./DepartmentDropdown.css";

const DepartmentDropdown = ({
  departments,
  selectedItems,
  onChange,
  userEmail,
  customerId,
}) => {
  const [selected, setSelected] = useState(selectedItems || []);
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelected(selectedItems || []);
  }, [selectedItems]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchQuery("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      setSearchQuery("");
    }
  };

  const handleSelect = (email) => {
    const updatedSelection = selected.includes(email)
      ? selected.filter((item) => item !== email)
      : [...selected, email];

    setSelected(updatedSelection);
    onChange(updatedSelection);
  };

  const handleUserEmailSelect = () => {
    if (!customerId) return;

    const idString = String(customerId);
    const updatedSelection = selected.includes(idString)
      ? selected.filter((item) => item !== idString)
      : [...selected, idString];

    setSelected(updatedSelection);
    onChange(updatedSelection);
  };

  const getFilteredItems = () => {
    if (!searchQuery.trim()) {
      return departments;
    }

    const query = searchQuery.toLowerCase();

    return departments
      .map((dept) => {
        const deptMatches = dept.name.toLowerCase().includes(query);

        const filteredMembers = dept.members.filter(
          (member) =>
            member.name.toLowerCase().includes(query) ||
            member.email.toLowerCase().includes(query)
        );

        if (deptMatches || filteredMembers.length > 0) {
          return {
            ...dept,
            members: filteredMembers,
          };
        }

        return null;
      })
      .filter(Boolean);
  };

  const filteredDepartments = getFilteredItems();
  return (
    <div className="department-dropdown-container" ref={dropdownRef}>
      <div className="dropdown-selection-display" onClick={handleToggle}>
        {selected.length > 0 ? (
          <div className="selected-tags">
            {selected.map((item) => {
              const label =
                customerId && item === String(customerId) ? userEmail : item;
              return (
                <span key={item} className="selected-tag">
                  {label.length > 30 ? `${label.substring(0, 30)}...` : label}
                  <button
                    className="remove-tag"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelect(item);
                    }}
                  >
                    ×
                  </button>
                </span>
              );
            })}
          </div>
        ) : (
          <span className="placeholder">เลือกผู้รับ...</span>
        )}

        <span className="dropdown-arrow">{isOpen ? "▲" : "▼"}</span>
      </div>

      {isOpen && (
        <div className="dropdown-menu">
          <div className="search-container">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="ค้นหา..."
              className="search-input"
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          <div className="dropdown-content">
            {userEmail && (
              <div className="dropdown-section">
                <div className="section-header">Customer</div>
                <div
                  className={`dropdown-item ${
                    selected.includes(String(customerId)) ? "selected" : ""
                  }`}
                  onClick={handleUserEmailSelect}
                >
                  <span className="checkbox">
                    {selected.includes(String(customerId)) ? "✓" : ""}
                  </span>
                  <span className="item-text">{userEmail}</span>
                </div>
              </div>
            )}
            {filteredDepartments.length > 0 ? (
              filteredDepartments.map((dept) => (
                <div key={dept.id} className="dropdown-section">
                  <div className="section-header">{dept.name}</div>
                  {dept.email && (
                    <div
                      className={`dropdown-item ${
                        selected.includes(dept.email) ? "selected" : ""
                      }`}
                      onClick={() => handleSelect(dept.email)}
                    >
                   
                    </div>
                  )}
                  {dept.members.map((member) => (
                    <div
                      key={member.email}
                      className={`dropdown-item ${
                        selected.includes(member.email) ? "selected" : ""
                      }`}
                      onClick={() => handleSelect(member.email)}
                    >
                      <span className="checkbox">
                        {selected.includes(member.email) ? "✓" : ""}
                      </span>
                      <span className="item-text">
                        {member.name} - {member.email}
                      </span>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <div className="no-results">ไม่พบผลลัพธ์ที่ตรงกัน</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DepartmentDropdown;
